
import { AppConfig, Menu } from "./interfaces/app-config";


export var globalConfig: AppConfig = {
  menu: [
    Menu.create({
      id: 2,
      path: '/home',
      title: 'Comprar',
    }),
    Menu.create({
      id: 3,
      path: '/tickets-saved',
      title: 'Mis Tickets',
    }),
  ],
  mobileMenu: [
    Menu.create({
      id: 1,
      path: '/home',
      title: 'Comprar',
      icon: '/assets/icons/home_white.svg',
      iconType: 'img'
    }),
    Menu.create({
      id: 3,
      path: '/tickets-saved',
      title: 'Mis Compras',
      icon: '/assets/icons/ticket_white.svg',
      iconType: 'img'
    }),
    // Menu.create({
    //     id: 3,
    //     path: '/search',
    //     title: 'Buscar',
    //     icon: '/assets/icons/search_white.svg',
    //     iconType: 'img'
    // }),
  ],
  footerMenu: [
    {
      id: 1,
      title: 'Páginas',
      menu: [
        Menu.create({
          id: 1,
          path: '/search',
          title: 'Términos de búsqueda',
          external: false,
        }),
        Menu.create({
          id: 2,
          path: '/privacy-policy',
          title: 'Política de privacidad y cookies',
          external: false,
        }),
        Menu.create({
          id: 3,
          path: 'https://staging.todotix.com/sales/guest/form/',
          title: 'Pedidos y devoluciones',
          external: true,
          target: "_blank"
        }),
        Menu.create({
          id: 4,
          path: 'https://staging.todotix.com/contact/',
          title: 'Contáctanos',
          external: true,
          target: "_blank"
        }),
        Menu.create({
          id: 4,
          path: '/search',
          title: 'Búsqueda avanzada',
          external: false,
        }),
        Menu.create({
          id: 4,
          path: '/affiliate-program',
          title: 'Programa de afiliación',
          external: false,
        }),
      ]
    },
    {
      id: 2,
      title: 'Contacto',
      menu: [
        Menu.create({
          id: 8,
          path: 'tel:59169777799',
          title: '59169777799',
          external: true,
          target: '_blank',
          icon: '/assets/icons/call.svg',
          iconType: 'img'
        }),
        Menu.create({
          id: 8,
          path: 'mailto:soporte@todotix.com',
          title: 'soporte@todotix.com',
          external: true,
          target: '_blank',
          icon: '/assets/icons/mail.svg',
          iconType: 'img'
        }),
        Menu.create({
          id: 8,
          path: 'https://www.facebook.com/libelula.bo',
          title: 'Todotix',
          external: true,
          target: '_blank',
          icon: '/assets/icons/facebook.svg',
          iconType: 'img'
        }),
        Menu.create({
          id: 9,
          path: 'https://www.instagram.com/libelula_bo',
          title: 'Todotix',
          external: true,
          target: '_blank',
          icon: '/assets/icons/instagram.svg',
          iconType: 'img'
        }),
        Menu.create({
          id: 10,
          path: 'https://api.whatsapp.com/send/?phone=59169777799&text=Tengo+una+consulta+respecto+a+Todotix&type=phone_number&app_absent=0',
          title: 'Todotix',
          external: true,
          target: '_blank',
          icon: '/assets/icons/whatsapp.svg',
          iconType: 'img'
        }),
      ]
    }
  ],
  pages: {
    login: {
      title: 'Inicia sesión en tu cuenta',
      subtitle: '¡Bienvenido de vuelta! Por favor, ingresa tus datos.',
      form: {
        email: {
          label: 'Correo electrónico',
          placeholder: 'Ingresa tu correo electrónico'
        },
        password: {
          label: 'Contraseña',
          placeholder: 'Ingresa tu contraseña'
        },
        rememberMe: {
          label: 'Recordarme'
        },
      },
      forgotPassword: '¿Olvidaste tu contraseña?',
      submit: 'Iniciar sesión',
      nextAuth: {
        question: '¿No tienes una cuenta?',
        action: 'Registrate'
      }
    },
    register: {
      title: 'Crea tu cuenta',
      subtitle: 'Por favor, ingresa los datos requeridos',
      form: {
        name: {
          label: 'Nombre completo',
          placeholder: 'Ingresa tu nombre completo'
        },
        email: {
          label: 'Correo electrónico',
          placeholder: 'Ingresa tu correo electrónico'
        },
        phone: {
          label: 'Teléfono celular',
          placeholder: 'Ingresa tu celular'
        },
        city: {
          label: 'Ciudad',
          placeholder: 'Selecciona tu ciudad'
        },
        credential: {
          label: 'Número de identificación',
          placeholder: 'Ingresa tu identificación'
        },
        password: {
          label: 'Contraseña',
          placeholder: 'Ingresa tu contraseña'
        },
        repeatPassword: {
          label: 'Repite la contraseña',
          placeholder: 'Repide tu contraseña'
        },
      },
      submit: 'Registrarse',
      nextAuth: {
        question: '¿Ya tienes una cuenta?',
        action: 'Inicia sesión'
      }
    },
    general: {
      serviceFee: 'Service Fee',
    }
  },
  validations: {
    required: "El campo \"{label}\" es requerido.",
    number: "El campo \"{label}\" debe contener solo números.",
    minlength: "El campo \"{label}\" debe tener al menos \"{requiredLength}\" caracteres.",
    maxlength: "El campo \"{label}\" debe tener un máximo de \"{requiredLength}\" caracteres.",
    min: "El campo \"{label}\" debe contener al menos \"{min}\" elementos.",
    max: "El campo \"{label}\" debe tener un máximo de \"{max}\" elementos.",
    email: "El campo \"{label}\" debe ser un email válido.",
    default: "El campo \"{label}\" es inválido.",
  },

  terms: `<p class="mb-3 text-center"><strong>TERMINOS Y CONDICIONES</strong></p><p class="mb-10 text-justify">El adquiriente de la presente entrada se hace total responsable por la información y claves de acceso que contenga dicha entrada, ya que dicha información será entregada y/o enviada únicamente al adquiriente de dicha entrada. Al ser una entrada digital, la misma puede ser utilizada para ingresar al evento en formato físico impreso o en formato digital mediante un dispositivo electrónico, por lo que la persona que presente dichas claves de acceso en el ingreso al evento podrá ingresar siempre y cuando la misma no haya ingresado previamente al mismo. En caso de que dichas claves de acceso caiga en manos de terceros el único responsable será el adquiriente de la entrada. La ejecución en la fecha, día y hora del evento para el cual es válida la presente entrada es de plena y única responsabilidad de la empresa productora del evento y en ningún caso de Todotix SRL. Los datos de la empresa o persona responsable del evento para cual la presente entrada es válida serán impresas en la parte anterior de esta entrada. Todotix SRL se libra de cualquier daño, lesión y/o muerte causada directa o indirectamente por la participación o asistencia al evento para la cual la presente entrada es válida. No se aceptan cambios. No se aceptan devoluciones. No se otorgan reembolsos. Entradas perdidas no serán reemplazadas ni reembolsadas. La devolución de dinero por la cancelación o no realización del evento será responsabilidad del organizador de eventos. Condiciones y términos sujetos escribir a legal@todotix.com. No será permitido el ingreso al evento con pirotecnia, grabadores, filmadoras, cámaras de fotografía y de video, ni cualquier elemento similar a los mencionados a criterio del Organizador, pudiendo los mismos ser retirados del lugar y destruido su contenido. El Organizador podrá solicitar que se apague todo equipo de radio llamada o teléfono celular antes del acceso al evento. El adquiriente de la presente entrada es responsable de revisar, aceptar y confirmar los términos y condiciones de su compra previo a realizarla. La edad mínima para la cual un niño o niña debe pagar la entrada será determinado por el organizador del evento. Todas las ventas son finales.</p><p class="mb-3 text-center"><strong>ADVERTENCIA</strong></p><p class="text-justify">Evite la compra de entradas de revendedores o de puntos de venta no autorizados ya que pueden ser falsificadas. La entrada cuenta con medidas de seguridad indetectables a la vista y con un código de barras el cual será registrado al ingreso al predio y será válido una sola vez. La utilización de una entrada falsificada para el ingreso al predio es ilegal, penalizado por ley y atenta contra la seguridad del público asistente.</p>`,

  authGoogle: false,
  authGuest: false,
  hasSearch: true,
  hasServiceFee: true,
  hasHeader: true,
  hasFooter: true,
  hasMobileMenu: true,
  hasFooterResponsive: false,
  underConstruction: null,
  hasIframe: false,
  staticMap: false,
  keyMap: 'AIzaSyCbWR6PgxPfBaPOgwkV0QRvvXhwxSDFyaM',
  organizator: 'Todotix',
  currency: 'Bs',
  zendeskKey: null,
  facebookPixelKey: null,
  appleWallet: false,
  googleWallet: false,
  bgDarkRoutes: [],
  bgCustomRoutes: [],
};
